// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background-color: #0d0d0d;
  color: #ccc;
  padding: 30px 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  flex-wrap: nowrap; /* keep all items on one line */
}

/* Left: Social links */
.footer-right {
  flex: 1 1 200px;
  display: flex;
  justify-content: flex-start; /* align left */
  gap: 20px;
  order: 1;
}

.footer-phone {
  flex: 1 1 200px;
  text-align: center;
  order: 2;
  color: #ccc;
  font-weight: 500;
}

/* Center: Copyright / business name */
.footer-left {
  flex: 1 1 300px;
  text-align: center;
  order: 3;
}

/* Right: Policies/Contact */
.footer-center {
  flex: 1 1 200px;
  display: flex;
  justify-content: flex-end; /* align right */
  gap: 25px;
  order: 4;
}

.footer-link {
  cursor: pointer;
  color: #aaa;
  margin: 0 10px;
  text-decoration: none;
}
.footer-link:hover {
  color: #f7931a;
}

.social-link {
  color: #aaa;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.social-link:hover {
  color: #f7931a; /* Royal Blue */
}

/* Responsive: stack vertically on smaller screens */
@media (max-width: 600px) {
  .footer-content {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }

  .footer-left,
  .footer-center,
  .footer-right {
    flex: none;
    justify-content: center !important;
    order: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/css/Footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,iBAAiB,EAAE,+BAA+B;AACpD;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,aAAa;EACb,2BAA2B,EAAE,eAAe;EAC5C,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,aAAa;EACb,yBAAyB,EAAE,gBAAgB;EAC3C,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,eAAe;AACjC;;AAEA,oDAAoD;AACpD;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;;;IAGE,UAAU;IACV,kCAAkC;IAClC,YAAY;EACd;AACF","sourcesContent":[".footer {\n  background-color: #0d0d0d;\n  color: #ccc;\n  padding: 30px 20px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 0.9rem;\n}\n\n.footer-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 15px;\n  flex-wrap: nowrap; /* keep all items on one line */\n}\n\n/* Left: Social links */\n.footer-right {\n  flex: 1 1 200px;\n  display: flex;\n  justify-content: flex-start; /* align left */\n  gap: 20px;\n  order: 1;\n}\n\n.footer-phone {\n  flex: 1 1 200px;\n  text-align: center;\n  order: 2;\n  color: #ccc;\n  font-weight: 500;\n}\n\n/* Center: Copyright / business name */\n.footer-left {\n  flex: 1 1 300px;\n  text-align: center;\n  order: 3;\n}\n\n/* Right: Policies/Contact */\n.footer-center {\n  flex: 1 1 200px;\n  display: flex;\n  justify-content: flex-end; /* align right */\n  gap: 25px;\n  order: 4;\n}\n\n.footer-link {\n  cursor: pointer;\n  color: #aaa;\n  margin: 0 10px;\n  text-decoration: none;\n}\n.footer-link:hover {\n  color: #f7931a;\n}\n\n.social-link {\n  color: #aaa;\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.3s ease;\n}\n\n.social-link:hover {\n  color: #f7931a; /* Royal Blue */\n}\n\n/* Responsive: stack vertically on smaller screens */\n@media (max-width: 600px) {\n  .footer-content {\n    flex-direction: column;\n    text-align: center;\n    gap: 10px;\n  }\n\n  .footer-left,\n  .footer-center,\n  .footer-right {\n    flex: none;\n    justify-content: center !important;\n    order: unset;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
